import { render, staticRenderFns } from "./Type2Block.vue?vue&type=template&id=ccc10872&scoped=true&"
import script from "./Type2Block.vue?vue&type=script&lang=js&"
export * from "./Type2Block.vue?vue&type=script&lang=js&"
import style0 from "./Type2Block.vue?vue&type=style&index=0&id=ccc10872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc10872",
  null
  
)

export default component.exports